































import { Component, Vue } from "vue-property-decorator";
import store, { modules } from "../store";
import { TypeClientele } from "../models/TypeClientele";
import {
  MDropdown,
  MDropdownItem,
  MSpinner,
  MPanel,
} from "@ulaval/modul-components";
import BoutonsNavigation from "../components/BoutonsNavigation.vue";

@Component({
  components: {
    MDropdown,
    MDropdownItem,
    MSpinner,
    BoutonsNavigation,
    MPanel,
  },
})
export default class Clientele extends Vue {
  private chargementEnCours: boolean = true;

  private async mounted(): Promise<void> {
    store.commit(modules.trainProgression.mutations.desactiverPrecedent.name);

    try {
      await store.dispatch(modules.cds.actions.recupererTypesClientele.name, {
        vm: this,
      });

      // Dans le cas où l'utilisateur avait déjà une sélection
      if (this.typeClienteleSelectionne !== "") {
        store.commit(modules.trainProgression.mutations.activerSuivant.name);
      }
    } catch (e) {
      store.commit(modules.cds.mutations.recupererTypesClienteleEchec.name);

      store.commit(
        modules.applicatif.mutations.modifierMessageErreur.name,
        store.state.applicatif.messageErreurParDefaut
      );
    }

    this.chargementEnCours = false;
  }

  get typeClienteleSelectionne(): string {
    return store.state.utilisateur.typeClientele?.id || "";
  }

  set typeClienteleSelectionne(idTypeClientele: string) {
    if (this.typeClienteleSelectionne !== idTypeClientele) {
      // Récupération du type de clientèle correspondant à l'identifiant reçu en paramètres.
      const typeClientele = this.typesClientele.find(
        (t) => t.id === idTypeClientele
      );

      store.commit(
        modules.utilisateur.mutations.sauvegarderTypeClientele.name,
        typeClientele
      );

      store.commit(modules.trainProgression.mutations.activerSuivant.name);
    }
  }

  get typesClientele(): TypeClientele[] {
    return store.state.cds.typesClientele;
  }
}
